export default (state = 0, action = {}) => {
    if (action.type === 'VIDEO_URL') {
        return action.payload;
    }
    return state;
};
